module.exports = __webpack_public_path__ + "img/2. New developments-th.7973e09.png";